import React from 'react';
import Pages from 'components/common/Pages';
import UpdatePage from 'components/Pages/Settings/SettingsMobile/UpdatePage';
import SuccessPage from 'components/Pages/Settings/SettingsMobile/SuccessPage';

const SettingsOverlay = ({
  closeOverlay,
  type,
  component,
  title,
  user,
  successTitle,
  successSummary,
  summary,
  accessor,
}) => {
  return (
  <div className="pb-8 pt-6 px-12 h-full" style={{ backgroundColor: '#F9F9F9' }}>
    <Pages>
      <UpdatePage
        Component={component}
        title={title}
        user={user}
        close={closeOverlay}
        summary={summary}
        accessor={accessor}
      />
      <SuccessPage
        title={title}
        close={closeOverlay}
        successTitle={successTitle}
        successSummary={successSummary}
        user={user}
      />
    </Pages>
  </div>
);}

export default SettingsOverlay;
